import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appScrollPageChange]',
})
export class ScrollPageChangeDirective {
  @Input('appScrollPageChange') shouldScroll?: string;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('mat-focus-indicator')) {
      let scroll: HTMLElement;
      this.shouldScroll = '.scrollTop';
      if (this.shouldScroll) {
        scroll = document.querySelector(this.shouldScroll) as HTMLElement;
      } else {
        scroll = window.document.body || window.document.documentElement;
      }

      if (scroll) {
        scroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}
